import AuthService from '../services/auth.service';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      console.log("working2")
      return AuthService.login(user).then(
        user => {
          console.log("USER", user.user)
          commit('loginSuccess', user.user);
          return Promise.resolve(user.user);
        },
        error => {
          commit('loginFailure');
          console.log("WOOPPP", error.response)
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },
    profile({ commit }, user) {
      let token = localStorage.getItem('EflexToken')
      const headers = {
        headers: {
          accept: 'application/vnd.github.v3.raw+json',
          Authorization: 'Bearer ' + token,
        }
      }
      console.log("YUP", headers, user)
      return AuthService.profile(headers, user).then(
        response => {
          commit('updateUser', user);
          localStorage.setItem('user', JSON.stringify(user));
          return Promise.resolve(true);
        },
        error => {
          return Promise.reject(error);
        }
      );

    },
    handleToken({ commit }, data) {
      let token = localStorage.getItem('EflexToken')
      const headers = {
        headers: {
          accept: 'application/vnd.github.v3.raw+json',
          Authorization: 'Bearer ' + token,
        }
      }

      return AuthService.token(data.code, headers).then(
        response => {
          commit('tokenSuccess');
          console.log("Token Success", response)
          return Promise.resolve(true);
        },
        error => {
          console.log("Token error:", error.response)
          return Promise.reject(error);
        }
      );
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        response => {
          commit('registerSuccess', response.data.user);
          localStorage.setItem('user', JSON.stringify(response.data.user));
          localStorage.setItem('EflexToken', response.data.accessToken)
          return Promise.resolve(response.data);
        },
        error => {
          commit('registerFailure');
          return Promise.reject(error);
        }
      );
    },
    forgotPassword({ commit }, user) {
      return AuthService.forgotPassword(user).then(
        user => {
          commit('forgotPasswordSuccess', user);
          return Promise.resolve(response.data);
        },
        error => {
          commit('forgotPasswordFailure');
          return Promise.reject(error);
        }
      );
    },
    resetPassword({ commit }, user) {
      return AuthService.resetPassword(user).then(
        user => {
          commit('resetPasswordSuccess', user);
          return Promise.resolve(response.data);
        },
        error => {
          commit('resetPasswordFailure');
          return Promise.reject(error);
        }
      );
    },
    changePassword({ commit }, user) {
      return AuthService.changePassword(user).then(
        user => {
          commit('changePasswordSuccess', user);
          return Promise.resolve(response.data);
        },
        error => {
          commit('changePasswordFailure');
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state, user) {
      state.status.loggedIn = false;
      state.user = user
    },
    updateUser(state, user) {
      state.user = user
    },
    tokenSuccess(state) {
      state.status.loggedIn = true
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
    forgotPasswordSuccess(state) {
      state.status.loggedIn = false;
    },
    forgotPasswordFailure(state) {
      state.status.loggedIn = false;
    },
    resetPasswordSuccess(state) {
      state.status.loggedIn = false;
    },
    resetPasswordFailure(state) {
      state.status.loggedIn = false;
    },
    changePasswordSuccess(state) {
      state.status.loggedIn = false;
    },
    changePasswordFailure(state) {
      state.status.loggedIn = true;
    }
  }
};
